import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface ICaraEntryPoint {
  readonly id: string;
  readonly type: MESSAGES.CARA_ENTRY_POINT;
  readonly rm: boolean;
  readonly role: ROLE.BOT;
  readonly avatar: boolean;
}

export const createCaraEntryPoint = (data: { id?: string; _id?: string }): ICaraEntryPoint => ({
  id: data.id ?? data._id ?? uuid(),
  type: MESSAGES.CARA_ENTRY_POINT,
  rm: false,
  role: ROLE.BOT,
  avatar: true,
});
